import { Controller } from "@hotwired/stimulus";
import { layoutThumbs } from "../help/shots";

const STORAGE_KEY = "help-platform";
const PLATFORMS = ["ios", "android"];

// Swaps every step whose picture differs between the iPhone and Android apps. The
// server renders both and shows the visitor's own phone first. A shot can only be
// sized while it shows, so the shots are sized again after every swap.
export default class extends Controller {
  static targets = ["button", "shot"];
  static values = { current: String };

  connect() {
    this.apply(this.storedPlatform() ?? this.currentValue);
  }

  choose(event) {
    const platform = event.currentTarget.dataset.platform;
    this.apply(platform);
    try {
      localStorage.setItem(STORAGE_KEY, platform);
    } catch {
      // Private mode or blocked storage. The choice still applies for this page.
    }
  }

  apply(platform) {
    if (!this.buttonTargets.some((button) => button.dataset.platform === platform)) return;

    this.shotTargets.forEach((shot) => {
      shot.hidden = shot.dataset.platform !== platform;
    });
    this.buttonTargets.forEach((button) => {
      button.setAttribute("aria-pressed", button.dataset.platform === platform ? "true" : "false");
    });
    layoutThumbs();
  }

  storedPlatform() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return PLATFORMS.includes(stored) ? stored : null;
    } catch {
      return null;
    }
  }
}
